/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_steps_shipped = /** @type {(inputs: {}) => string} */ () => {
	return `Odesláno`
};

const da_order_steps_shipped = /** @type {(inputs: {}) => string} */ () => {
	return `Afsendt`
};

const de_order_steps_shipped = /** @type {(inputs: {}) => string} */ () => {
	return `Versandt`
};

const en_order_steps_shipped = /** @type {(inputs: {}) => string} */ () => {
	return `Shipped`
};

const es_order_steps_shipped = /** @type {(inputs: {}) => string} */ () => {
	return `Enviado`
};

const fr_order_steps_shipped = /** @type {(inputs: {}) => string} */ () => {
	return `Expédiée`
};

const hu_order_steps_shipped = /** @type {(inputs: {}) => string} */ () => {
	return `Szállítva`
};

const it_order_steps_shipped = /** @type {(inputs: {}) => string} */ () => {
	return `Spedito`
};

const nl_order_steps_shipped = /** @type {(inputs: {}) => string} */ () => {
	return `Verzonden`
};

const pl_order_steps_shipped = /** @type {(inputs: {}) => string} */ () => {
	return `Wysłano`
};

const pt_order_steps_shipped = /** @type {(inputs: {}) => string} */ () => {
	return `Enviado`
};

const sv_order_steps_shipped = /** @type {(inputs: {}) => string} */ () => {
	return `Skickad`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const order_steps_shipped = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_steps_shipped(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_steps_shipped", locale)
	if (locale === "cs") return cs_order_steps_shipped(inputs)
	if (locale === "da") return da_order_steps_shipped(inputs)
	if (locale === "de") return de_order_steps_shipped(inputs)
	if (locale === "en") return en_order_steps_shipped(inputs)
	if (locale === "es") return es_order_steps_shipped(inputs)
	if (locale === "fr") return fr_order_steps_shipped(inputs)
	if (locale === "hu") return hu_order_steps_shipped(inputs)
	if (locale === "it") return it_order_steps_shipped(inputs)
	if (locale === "nl") return nl_order_steps_shipped(inputs)
	if (locale === "pl") return pl_order_steps_shipped(inputs)
	if (locale === "pt") return pt_order_steps_shipped(inputs)
	return sv_order_steps_shipped(inputs)
};
export { order_steps_shipped as "order_steps.shipped" }